import React, { useEffect, useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import logo from "../../images/logo.png";
import android from "../../images/android.png";
import { FaApple, FaTiktok, FaYoutube } from "react-icons/fa";
import { Flex } from "../../styles/global.syles";
import { NavbarContainer } from "./Navbar.styles";

const Navbar = () => {
  const [isFixed, setIsFixed] = useState(false);
  const [shouldShow, setShouldShow] = useState(false);
  const [shownav, setShownav] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const top = window.pageYOffset || document.documentElement.scrollTop;
      if (top > 100 && top <= 300) {
        setIsFixed(true);
        setShouldShow(false);
      } else if (top > 300) {
        setIsFixed(true);
        setShouldShow(true);
      } else {
        setIsFixed(false);
        setShouldShow(false);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Prevent background scroll when mobile navigation is open
  useEffect(() => {
    if (shownav) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [shownav]);

  const closeNav = () => setShownav(false);

  return (
    <NavbarContainer
      isFixed={isFixed}
      shouldShow={shouldShow}
      shownav={shownav}
    >
      {/* Dim backdrop on mobile when menu is active */}
      {shownav && <div className="nav-backdrop" onClick={closeNav} />}

      <div className="container">
        <Flex justify="space-between" className="nav-header-flex">
          {/* logo */}
          <div className="logo">
            <Link to="/" onClick={closeNav}>
              <img src={logo} alt="Beyond Lottery" width="165" />
            </Link>
          </div>

          {/* links */}
          <div className="links">
            <div className={`nav-menu-links ${shownav ? "active" : ""}`}>
              <Link to="/" className="nav-item-link active" onClick={closeNav}>
                Home
              </Link>
              <a href="#features" className="nav-item-link" onClick={closeNav}>
                Features
              </a>
              <a href="#pricing" className="nav-item-link" onClick={closeNav}>
                Pricing
              </a>
              <a href="#services" className="nav-item-link" onClick={closeNav}>
                Services
              </a>
              <a href="#contact-us" className="nav-item-link" onClick={closeNav}>
                Contact us
              </a>

              <a href="#download-app" className="nav-download-item" onClick={closeNav}>
                <span>Download</span>
                <FaApple className="apple-icon" />
                <img src={android} alt="Android App" className="android-icon" />
              </a>

              <div className="nav-social-wrap">
                <a
                  href="https://www.tiktok.com/@beyondlotto7?_r=1&_t=ZP-9AKXK2mfBvj"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="nav-social-btn tiktok"
                  title="Follow us on TikTok"
                  aria-label="TikTok"
                >
                  <FaTiktok />
                </a>
                <a
                  href="https://youtube.com/@beyondlottery?si=EXAbnJXS3tD2N3o3"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="nav-social-btn youtube"
                  title="Watch us on YouTube"
                  aria-label="YouTube"
                >
                  <FaYoutube />
                </a>
              </div>

              <Link to="/login" onClick={closeNav} className="nav-login-link">
                <button className="nav-login-btn">Login</button>
              </Link>
            </div>

            {/* mobile hamburger toggle */}
            <button
              type="button"
              className="bars"
              onClick={() => setShownav((prevState) => !prevState)}
              aria-label={shownav ? "Close navigation menu" : "Open navigation menu"}
              aria-expanded={shownav}
            >
              {shownav ? <FaTimes /> : <FaBars />}
            </button>
          </div>
        </Flex>
      </div>
    </NavbarContainer>
  );
};

export default Navbar;
